export const MENU_HIDDEN = 'menu_hidden';
export const MENU_SHOWN = 'menu_shown';
export const SET_MENU_REF = 'set_menu_ref';
